import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError  } from "rxjs";
import { map } from 'rxjs/operators';
import { jwtDecode } from "jwt-decode";

import { environment } from '../../../environments/environment';

@Injectable()
export class AuthServerProvider {
	resetInterceptorState: (() => void) | null = null;
	constructor(
		private http: HttpClient
	) { }

	getToken() {
		return localStorage.getItem('access_token');
	}

	login(credentials: any): Observable<any> {
		return this.http.post(environment.resourceUrl + '/auth/login', credentials, { observe: 'response' })
			.pipe(
				map((resp: any) => {
					const jwt = resp.body.access_token;
					this.storeAuthenticationToken(jwt);
					const refresh_token = resp.body.refresh_token;
					this.storeAuthenticationTokenLogin(refresh_token);
					this.getDecodedToken();
					return jwt;
				})
			);
	}
	storePermissions(permissions: string[]) {
		localStorage.setItem('permissions', (permissions || []).join(','));
	}
	getDecodedToken() {
		const token = localStorage.getItem('access_token');
		if (token) {
			try {
				const decoded: any = jwtDecode(token);
				const allRoles: string[] = decoded?.realm_access?.roles || [];
				
				const appRoles = ['ADMIN', 'DEVELOPER', 'VIEWER'];
				const roles = allRoles.filter((r: string) => appRoles.includes(r));
				const permissions = allRoles.filter((r: string) => !appRoles.includes(r)
					&& !r.startsWith('default-roles')
					&& r !== 'offline_access'
					&& r !== 'uma_authorization');

				this.storeRoles(roles);
				this.storePermissions(permissions);
			} catch (error) {
				console.error('Token is invalid or expired', error);
			}
		}
	}
	storeRoles(roles: string[]) {
    	localStorage.setItem('roles', (roles || []).join(','));
	}

		refreshToken(): Observable<any> {
			const data = {
				username: localStorage.getItem('username'),
				refresh_token: localStorage.getItem('refresh_token')
			};
			if (!data.refresh_token) {
				return throwError(() => new Error('No refresh token found'));
			}
			return this.http.post(environment.resourceUrl + '/auth/refresh-token', data, { observe: 'response' })
				.pipe(
					map((resp: any) => {
						const jwt = resp.body.access_token;
						this.storeAuthenticationToken(jwt);
						this.getDecodedToken(); 
						return jwt;
					})
				);
		}
	

	logout(): Observable<any> {
		const data = {
			username: localStorage.getItem('username'),
			refresh_token: localStorage.getItem('refresh_token')
		};
		return this.http.post(environment.resourceUrl + '/auth/logout', data, { observe: 'response', responseType: 'text' })
			.pipe(
				map((resp: any) => {
					localStorage.removeItem("access_token");
					localStorage.removeItem("refresh_token");
					localStorage.removeItem("user_id");
					localStorage.removeItem("username");
					localStorage.removeItem("roles");
					localStorage.removeItem("permissions"); 
					return resp;
				})
			);
	}

	storeAuthenticationUsername(username: any) {
		localStorage.setItem("username", username);
	}

	

	storeUserId(user_id: any) {
		localStorage.setItem("user_id", user_id);
	}

	storeAuthenticationToken(jwt: any) {
		localStorage.setItem("access_token", jwt);
	}

	storeAuthenticationTokenLogin(jwt: any) {
		localStorage.setItem("refresh_token", jwt);
	}
	clearLocalStorage() {
		localStorage.removeItem("access_token");
		localStorage.removeItem("refresh_token");
		localStorage.removeItem("user_id");
		localStorage.removeItem("username");
		localStorage.removeItem("roles");
		localStorage.removeItem("permissions");
	}
}